<template>
  <!-- <v-container fill-height grid-list-xl> -->
  <v-layout justify-center wrap>
    <section id="aboutSectionHeader" style="position:relative;min-width:100vw;height:500px">
      <v-img
        height="100%"
        position="center center"
        :src="require('../assets/Headers/Join-us_text-01.jpg')"
        class="hidden-xs-only"
      />
      <v-img
        height="300"
        position="center center"
        :src="require('../assets/Headers/Join-us_text-01.jpg')"
        class="hidden-sm-and-up"
      />
    </section>

    <v-container grid-list-xl class="pageContent" style="margin-top: 40px;">
      <v-layout column>
        <v-layout row wrap justify-space-around align-start style="padding-bottom: 50px;">
          <v-flex xs12 style="text-align: center;">
            <div
              class="headline"
              style=" font-weight: bold !important;font-family: 'Aleo' !important;font-size: 30pt !important;color: black;"
            >I'm interested in knowing more about</div>
          </v-flex>
          <v-flex xs12 sm6 md4 justify-space-around>
            <v-card
              tile
              style="border-radius: 0 !important; box-shadow: none !important; background: none;"
              @click="$router.push(`/SupplierJoin`)"
            >
              <v-img
                :src="require('../assets/Values/Approved_Supplier-04.png')"
                class="joinOptionCards"
                style=" cursor: pointer; height: 250px;"
                contain
              />
              <v-card-text
                class="nl2br"
                style="font-size: 13pt"
              >UpstreamNZ suppliers have been approved for quality and integrity. They provide their services in order to create impact</v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 justify-space-around>
            <v-card
              tile
              style="border-radius: 0 !important; box-shadow: none !important; background: none;"
              @click="$router.push(`/GoodCauseJoin`)"
            >
              <v-img
                :src="require('../assets/Values/UpstreamNZ-Badge-03.png')"
                class="joinOptionCards"
                style=" cursor: pointer; height: 250px;"
                contain
              />
              <v-card-text
                class="nl2br"
                style="font-size: 13pt"
              >School based or charitable organisations that agree to put their contributions towards strengthening the well-being of young people</v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4 justify-space-around>
            <v-card
              tile
              style="border-radius: 0 !important; box-shadow: none !important; background: none;"
              @click="$router.push(`/ImpactBusinessJoin`)"
            >
              <v-img
                :src="require('../assets/Values/UpstreamNZ Badges-05.png')"
                class="joinOptionCards"
                style=" cursor: pointer; height: 250px;"
                contain
              />
              <v-card-text
                class="nl2br"
                style="font-size: 13pt"
              >Impact Businesses are organisations that create impact by using our suppliers in their supply chain to benefit our mission</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      tab: null,
      joins: [
        {
          title: "Supplier",
          background: "background: #4cc7e8;",
          link: "/SupplierJoin",
          imgSrc: "../assets/Values/Approved_Supplier-04.png"
        },
        {
          title: "Good Cause",
          background: "background: #59595c;",
          link: "/GoodCauseJoin",
          imgSrc: "../assets/Values/UpstreamNZ-Badge-03.png"
        },
        {
          title: "Impact Customer",
          background: "background: #4cc7e8;",
          link: "/ImpactCustomerJoin",
          imgSrc: "../assets/Values/UpstreamNZ-Badge-01.png"
        }
      ]
    }),
    computed: {
      ...mapGetters({
        user: "user",
        services: "business/services",
        categories: "categories/list",
        categoriesByName: "categories/byName"
      })
    },
    methods: {}
  };
</script>

<style>
  .application {
    background-color: white !important;
  }
</style>

<style scoped>
  .nl2br {
    white-space: pre-line;
  }

  .cardTitleHeader {
    text-align: center;
    height: 130px;
    background: #4cc7e8;
  }

  @media only screen and (max-width: 600px) {
    section#aboutSectionHeader {
      height: 100% !important;
    }
  }

  @media only screen and (min-width: 1904px) {
    .pageContent {
      max-width: 1200px;
    }
  }

  .display-3 {
    font-family: "Aleo" !important;
  }
</style>
